import React from 'react';
import HeroSection from './components/HeroSection';
import ClientLogosSection from '../../components/ClientLogosSection';
import WhyChooseMeSection from './components/WhyChooseMeSection';
import AboutMeSnippet from './components/AboutMeSnippet';
import KeySkillsSection from './components/KeySkillsSection';
import ServicesSection from './components/ServicesSection'; // Import ServicesSection
import RecentProjectsSection from './components/RecentProjectsSection';
import TestimonialsSlider from './components/TestimonialsSlider';
import BlogSection from './components/BlogSection';
import FAQSection from './components/FAQSection';
import CallToActionSection from './components/CallToActionSection';
import MetaTagsUpdater from '../../components/MetaTagsUpdater'; // Import MetaTagsUpdater

function Home() {
  const yearsOfExperience = new Date().getFullYear() - 2019;

  return (
    <div className="min-h-screen bg-bg-dark text-text-gray font-sans">
      <MetaTagsUpdater pageKey="Home" />
      <HeroSection yearsOfExperience={yearsOfExperience} />
      <ClientLogosSection />
      <WhyChooseMeSection />
      <AboutMeSnippet yearsOfExperience={yearsOfExperience} />
      <KeySkillsSection />
      <ServicesSection />
      <RecentProjectsSection />
      <TestimonialsSlider />
      <BlogSection />
      <FAQSection />
      <CallToActionSection />
    </div>
  );
}

export default Home;